<!--产品详情-->
<template>
  <div class="product-container">
    <headerIndex/>
    <div class="service-content">
      <p class="SourceHanSansCN title">{{ pName ? pName : childNode.name+'企业数字化服务云平台' }}
        <el-input class="search-input" placeholder="请输入关键词" @keyup.enter.native="search" v-model="keyword">
          <span class="red-btn SourceHanSansCN" slot="suffix" @click="search">搜索</span>
        </el-input>
      </p>
      <div class="recommend-search">
        <el-link v-for="rec of recommendSearch" :underline="false" @click="checkRecommend(rec)">{{ rec }}</el-link>
      </div>
    </div>
    <div class="navigator">
      <el-link type="primary" class="link-white" :underline="false" @click="shopInfo(bqwShop)">全部产品</el-link>
      <el-link type="primary" class="link-white" :underline="false" v-for="(category,index) of categoryList" @click="shopGoodsInfo(category)">
        <el-divider direction="vertical"/>
        <span>{{ category.name }}</span>
      </el-link>
    </div>
    <div class="toolbar-content">
      <div class="left-toolbar">
        <span style="float:left;">您所在的位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a @click="goBack">{{ pName }}</a></el-breadcrumb-item>
          <el-breadcrumb-item v-if="serviceList">{{ serviceList.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="right-toolbar">
        <el-link class="right-link" :underline="false" @click="shopInfo(bqwShop)">
          <i class="iconfont icon-bqw-shop"/>{{ bqwShop.name }}
        </el-link>
        <el-link class="right-link" :underline="false" @click="ContactCustomer"><i class="iconfont icon-bqw-customer"/>联系客服</el-link>
        <el-link class="right-link" :underline="false" v-if="!attentionShop" @click="followStore(1)">
          <i class="iconfont icon-bqw-follow"/>关注店铺
        </el-link>
        <el-link class="right-link" :underline="false" v-else @click="followStore(0)">
          <i class="iconfont icon-followed"/>已关注
        </el-link>
      </div>
    </div>
    <div class="product-content" :style="'min-height:'+min_height+'px;'">
      <el-container style="padding-bottom: 20px;">
        <el-aside class="swiper-wrapper-content" width="350px">
          <swiper :options="swiperOptionTop" class="gallery-top imgs" ref="swiperTop">
            <swiper-slide class="slide-1 imgsList" v-for="item in bigImg">
              <div class="swiper-zoom-container">
                <img :src="item"/>
              </div>
            </swiper-slide>
            <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
            <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
          </swiper>
          <!-- swiper2 Thumbs -->
          <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs" v-if="bigImg.length>1">
            <swiper-slide class="slide-1" v-for="item in bigImg">
              <img :src="item"/>
            </swiper-slide>
          </swiper>
        </el-aside>
        <el-main>
          <div class="details-content">
            <p class="title SourceHanSansCN">{{ details.bgGood.name }}</p>
            <div class="details-info">
              <span class="span-default">价格</span>
              <span class="span-red SourceHanSansCN">
                <span class="span-smaller">￥</span>{{ parseFloat(details.bgGood.price).toFixed(2) }}
              </span>
            </div>
            <div class="details-info" v-if="couponsList!=undefined && couponsList.length>0">
              <span class="span-default" style="float: left;">领劵</span>
              <div @click="moreCoupons">
                <div class="preferential-amount" v-for="(item,index) of couponsList">
                  <div class="preferential" v-if="index<3">
                    <span>满{{ item.usingDoor }}减</span><span>{{ item.preferentialAmount }}</span>
                  </div>
                </div>
                <i class="el-icon-arrow-right"/>
              </div>
            </div>
            <div class="details-info" v-if="details.banLiCitys!=undefined && details.banLiCitys.length>0">
              <span class="span-default" style="float: left;">服务地区</span>
              <el-select v-model="serviceArea.province" placeholder="请选择" @change="changeProvince"
                         style="width: 160px;">
                <el-option v-for="city in details.banLiCitys" :label="city.province" :value="city.id"/>
              </el-select>
              <el-select v-model="serviceArea.city" placeholder="请选择" @change="changeCity"
                         style="padding-left: 20px;width: 160px;">
                <el-option v-for="sonList in cityList" :label="sonList.area" :value="sonList.id"/>
              </el-select>
            </div>
            <div class="details-info">
              <span class="span-default" style="float: left;">数量</span>
              <el-input-number v-model="count" :min="1" :max="999" label="描述文字"></el-input-number>
            </div>
            <div class="details-info" @click="serviceGuarantee">
              <span class="span-default" style="float: left;">服务保障</span>
              <span class="span-gray"><i class="el-icon-circle-check"/>价格透明</span>
              <span class="span-gray"><i class="el-icon-circle-check"/>安心交易</span>
              <span class="span-gray"><i class="el-icon-circle-check"/>保障服务</span>
              <i class="el-icon-arrow-right"/>
            </div>
            <div class="details-info">
              <span class="span-default"></span>
              <el-button type="danger" @click="placeOrder">立即购买</el-button>
              <el-button type="danger" plain @click="ContactCustomer">在线咨询</el-button>
              <el-button type="danger" class="copyBtn" plain v-if="bqwShop.phone" :data-clipboard-text="bqwShop.phone" @click="copyPhone(bqwShop.phone)">电话咨询</el-button>
            </div>
          </div>
        </el-main>
        <el-main style="padding: 0px">
          <p class="title-small">推荐顾问</p>
          <div class="shop" v-for="item of recommendConsultants">
            <div class="shop-info">
              <el-avatar :src="item.avatar" :size="45" style="float: left" v-if="item.avatar"/>
              <div class="user-content">
                <p><span class="SourceHanSansCN" style="color: #333333;padding-right: 10px;">{{ item.name }}</span>
                  <i class="icon-orange">{{ item.professionalDdvisers }}</i>
                  <i class="iconfont icon-bqw-telephone"></i>
                </p>
                <p class="default-p">擅长业务：体系认证、品牌认证</p>
              </div>
            </div>
            <div class="statistics">
              <div>
                <p class="span-block SourceHanSansCN">1243</p>
                <p>服务客户</p>
              </div>
              <div>
                <p class="span-block SourceHanSansCN">1243</p>
                <p>成交数量</p>
              </div>
              <div>
                <p class="span-block SourceHanSansCN">{{ item.workingYears }}</p>
                <p>从业年限</p>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
      <el-container class="container-info">
        <el-aside width="300px">
          <div class="container-left-top">
            <div class="shop-title">{{ bqwShop.name }}</div>
            <div class="container-btn">
              <el-link class="right-link" :underline="false" style="border-right: none;" @click="shopInfo(bqwShop)"><i
                  class="iconfont icon-bqw-shop"/>进店看看
              </el-link>
              <el-link class="right-link" :underline="false" v-if="!attentionShop" @click="followStore(1)">
                <i class="iconfont icon-bqw-follow"/>关注店铺
              </el-link>
              <el-link class="right-link" :underline="false" v-else @click="followStore(0)">
                <i class="iconfont icon-followed"/>已关注
              </el-link>
            </div>
          </div>
          <div class="container-left-bottom">
            <div class="shop-title">店铺热销</div>
            <div class="recommend-list">
              <div v-for="(recommend,index) of recommends" v-if="index<5">
                <el-image :src="recommend.image" style="width: 100%;height: 100%"/>
                <p class="recommend-name">{{ recommend.name }}</p>
                <p class="recommend-price SourceHanSansCN"><span>￥</span>{{ parseFloat(recommend.price).toFixed(2) }}
                </p>
              </div>
            </div>
          </div>
        </el-aside>
        <el-main>
          <div class="container-right-top" style="border-bottom: 1px solid #FE273B;">
            <el-radio-group v-model="isCollapse" @change="handleChange">
              <el-radio-button label="1">商品详情</el-radio-button>
              <el-radio-button label="2">累计评价(
                <span>{{ commentCount > 0 ? commentCount : 0 }}</span>)
              </el-radio-button>
            </el-radio-group>
          </div>
          <div class="details-info" ref="info" v-if="details.xiangqing.length>0">
            <div v-for="xiangqing of details.xiangqing">
              <el-image :src="xiangqing.image" style="width: 100%;height: auto;"/>
            </div>
          </div>
          <div class="details-info" ref="info" v-else>
            <div v-html="details.bgGood.introduction"/>
          </div>
          <div class="container-right-top SourceHanSansCN" ref="comment" style="padding: 20px;font-size: 14px;">
            累计评价(<span>{{ commentCount > 0 ? commentCount : 0 }}</span>)
          </div>
          <div class="comment">
            <div class="comment-eval">
              <div class="comment-score SourceHanSansCN">
                <p clas="span-1">好评度</p>
                <p class="span-red">{{ goodsPraiseRate }}%</p>
              </div>
              <div class="eval">
                <i v-for="pjbq of details.pjbq" class="eval-label">{{ pjbq }}</i>
              </div>
            </div>
            <div class="comment-list" v-for="comment of details.goodsComments" v-if="commentCount>0">
              <div class="comment-user">
                <el-image :src="comment.avatar" fit="contain" style="height: 48px;width: 48px;border-radius: 50%"
                          v-if="comment.avatar"/>
                <el-image v-else
                          style="height: 48px;width: 48px;border-radius: 50%;display: flex;justify-content: center;background: #F1F1F1;align-items: center;">
                  <div slot="error" class="image-slot"><i class="el-icon-picture-outline" style="font-size: 30px;"/>
                  </div>
                </el-image>
                <el-link :underline="false" style="padding-left: 10px">{{ comment.userName || '--' }}</el-link>
              </div>
              <div style="padding-top: 16px;padding-left: 200px;">
                <el-rate v-model="comment.grade" disabled :colors="['#FE273B', '#FE273B', '#FE273B']"/>
                <div>{{ comment.content }}</div>
                <div v-if="comment.imageArray">
                  <el-image v-for="imageArray of comment.imageArray" :src="imageArray" fit="contain"
                            style="height: 116px;width: 146px;margin-right: 10px;margin-top: 10px;"/>
                </div>
                <div class="time">{{ timestampToTime(comment.time) }}</div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
    <el-drawer title="领取优惠券" :visible.sync="drawer" size="300px" custom-class="drawer-comment" :append-to-body="true">
      <div style="padding: 20px">
        <p style="margin-block-start: 0;margin-block-end: 0;">可领取的优惠券</p>
        <div class="coupon" v-for="coupon of couponsArray">
          <p style="margin-block-start: 0em;cursor: context-menu;">
            <span class="red-p SourceHanSansCN">￥</span>
            <span class="red-p SourceHanSansCN" style="font-size: 24px;padding-right: 20px;">{{
                coupon.usingDoor
              }}</span>
            <!--优惠券类型（1新人专享优惠券 2商品优惠券 3店铺优惠券)-->
            <span class="red-p SourceHanSansCN" v-if="coupon.type==1">新人专享优惠券</span>
            <span class="red-p SourceHanSansCN" v-else-if="coupon.type==2">商品优惠券</span>
            <span class="red-p SourceHanSansCN" v-else-if="coupon.type==3">店铺优惠券</span>
          </p>
          <p class="small-p SourceHanSansCN">满{{ coupon.usingDoor }}减{{ coupon.preferentialAmount }}</p>
          <p class="small-p SourceHanSansCN" style="font-size: 12px;">{{ coupon.startTime }}-{{ coupon.endTime }}</p>
          <div :class="coupon.isReceive==1 ? 'disabled-button SourceHanSansCN' : 'red-button SourceHanSansCN'"
               @click="getCoupon(coupon)"
               :disabled="coupon.isReceive==1 ? true : false">{{ coupon.isReceive == 1 ? '已领取' : '立即领取' }}
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog title="服务保障" :visible.sync="dialogGuaranteeVisible" width="500px" class="guarantee-dialog">
      <p><span class="span-gray"><i class="el-icon-circle-check"/>价格透明</span></p>
      <p class="gray-p">全程价格透明，无隐形收费</p>
      <el-divider/>
      <p><span class="span-gray"><i class="el-icon-circle-check"/>安心交易</span></p>
      <p class="gray-p">交易资金平台实时监控，保证资金安全</p>
      <el-divider/>
      <p><span class="span-gray"><i class="el-icon-circle-check"/>保障服务</span></p>
      <p class="gray-p">全程监理，让你对服务进度了如指掌，保证服务质量</p>
    </el-dialog>
    <Hang/>
    <home_footer/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import cityJson from "@/static/cityJson.json";
import {
  newEvaluate,
  newShopClass,
  hotShop,
  goodRecommendedConsultant,
  goodsForCoupons,
  couponsAvailableList,
  getCoupons,
  saveCollect,
  removeCollect,
  joinShop, hotSearchKeywords
} from '@/api/cloudServiceApi'
import {swiper, swiperSlide} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "productDetails",
  components: {headerIndex, home_footer, Hang, swiper, swiperSlide},
  data() {
    return {
      bigImg: [],
      min_height: document.documentElement.clientHeight - 318,
      details: {
        bqwShop: {name: ''},
        bgGood: {name: ''},
        goodsComments: [],
        banLiCitys: [],
        xiangqing: [],
      },
      commentCount: 0,
      recommends: [],
      pName: '企业数字化服务云平台',
      keyword: '',
      showConnect: false,
      dialogGuaranteeVisible: false,
      timer: null,
      recommendSearch: [],
      serviceArea: {province: '', city: ''},
      count: 1,
      isCollapse: 1,
      goodsPraiseRate: 95,
      drawer: false,
      timeout: null,
      city: {city: '', province: ''},
      cityList: [],
      serviceList: null,
      serviceData: null,
      cid: 0,
      categoryList: [],
      recommendConsultants: [],
      swiperOptionTop: {
        effect: "fade",
        orderType: 0,
        virtualTranslate: true,
        pauseOnMouseEnter: true,
        maxBackfaceHiddenSlides: true,
        zoom: true,
        rewind: true,
        watchOverflow: true,
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        autoplay: {delay: 4000, disableOnInteraction: true,}
      },
      swiperOptionThumbs: {
        spaceBetween: 20,
        slidesPerView: 'auto',/*slider容器能够同时显示的slides数量*/
        centeredSlides: true,/*居中幻灯片*/
        touchRatio: 0.5,
        slideToClickedSlide: true,
        maxBackfaceHiddenSlides: true,

        autoplay: {delay: 4000, speed: 1000, disableOnInteraction: true,}
      },
      swiperSlides: [],
      /*优惠券*/
      couponsList: [],
      couponsArray: [],
      /*店铺关注状态*/
      attentionShop: false,
      bqwShop: {},
      childNode:{},
    }
  },
  methods: {
    /*键入推荐搜索*/
    checkRecommend(val) {
      this.keyword = val;
    },
    /*获取搜索推荐*/
    getHotSearchKeywords() {
      hotSearchKeywords().then(res => {
        if (res.code == 200) {
          this.recommendSearch = res.content.list;
        }
      })
    },
    search() {
      if (this.keyword) {
        this.$router.push({
          path: '/cloudPlatform/AllService',
          query: {
            pName: this.pName,
            keyword: this.keyword
          }
        })
      } else
        this.$message.error('请输入关键词搜索。');
    },
    /*返回上一级页面*/
    goBack() {
      this.$router.back(-1);
    },
    handleChange(val) {
      if (val == 1)
        window.scrollTo(0, this.$refs.info.offsetTop - 100);
      else
        window.scrollTo(0, this.$refs.comment.offsetTop);
    },
    // 时间格式
    timestampToTime(timestamp) {
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    /*店铺信息*/
    shopInfo(row) {
      this.$router.push({
        path: '/storeManagement/shop',
        query: {
          id: row.id,
          pName: this.pName
        }
      })
    },
    /*商品分类获取列表数据*/
    shopGoodsInfo(row){
      this.$router.push({
        path: '/storeManagement/shop',
        query: {
          id: this.bqwShop.id,
          pName: this.pName,
          activeName:row.id,
        }
      })
    },
    /*提交订单*/
    placeOrder() {
      this.$router.push({
        path: '/payment/order',
        query: {
          goodId: this.details.bgGood.id,
          province: this.serviceArea.province,
          city: this.serviceArea.city,
          count: this.count,
          city_name: this.city.city,
          province_name: this.city.province
        }
      })
    },
    changeProvince(val, $event) {
      for (let item of this.details.banLiCitys) {
        if (item.id == val) {
          this.city.province = item.province;
          this.cityList = item.sonList;
        }
      }
    },
    changeCity(val, $event) {
      for (let item of this.cityList) {
        if (item.id == val) {
          this.city.city = item.area;
        }
      }
    },
    /*获取商品详情*/
    getNewEvaluate() {
      newEvaluate({
        id: this.$route.query.id,
        userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
      }).then(res => {
        if (res.code == 200) {
          this.details = res.content;
          this.commentCount = res.content.goodsComments.length;
          this.bigImg = res.content.bgGood.swiperArray ? res.content.bgGood.swiperArray : [res.content.bgGood.swiper]
          this.getNewShopClass();
          this.getHotShop();
          this.getShopStatus();
        }
      })
    },
    /*获取店铺下的商品分类*/
    getNewShopClass() {
      newShopClass({
        shopId: this.details.bqwShop.id,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
      }).then(res => {
        if (res.code == 200) {
          this.categoryList = res.content.categoryList;
        }
      })
    },
    /*获取店铺热销*/
    getHotShop() {
      hotShop({shopId: this.details.bqwShop.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.recommends = res.content.list;
        }
      })
    },
    /*推荐顾问*/
    getGoodRecommendedConsultant() {
      goodRecommendedConsultant({productId: this.$route.query.id}).then(res => {
        if (res.code == 200) {
          this.recommendConsultants = res.content;
        }
      })
    },
    /*是否有优惠券可领取*/
    getGoodsForCoupons() {
      goodsForCoupons({
        id: this.$route.query.id,
        userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
      }).then(res => {
        if (res.code == 200) {
          this.couponsList = res.content.couponsList;
        }
      })
    },
    /*获取更多优惠券*/
    moreCoupons() {
      couponsAvailableList({
        id: this.$route.query.id,
        request: 'form',
        userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.couponsArray = res.content.coupon;
          this.drawer = true;
        }
      })
    },
    /*领取优惠券*/
    getCoupon(data) {
      if (data.isReceive == 0) {
        getCoupons({
          cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
          uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
          couponId: data.couponId,
          request: 'form',
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('领取成功！');
            this.getNewEvaluate();
            this.getGoodsForCoupons();
            this.getGoodRecommendedConsultant();
            this.drawer = false;
          } else {
            this.$message.error('领取失败！');
          }
        })
      }
    },
    /*获取店铺关注状态*/
    getShopStatus() {
      joinShop({
        request: 'form',
        shopId: this.details.bqwShop.id,
        userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
      }).then(res => {
        if (res.code == 200) {
          this.attentionShop = res.content.attentionShop;
          this.bqwShop = res.content.bqwShop;
        }
      })
    },
    /*关注店铺*/
    followStore(status) {
      /*关注店铺*/
      if (status == 1) {
        saveCollect({
          request: 'form', id: this.bqwShop.id, shopType: this.bqwShop.shopType, type: 2,
          cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
          userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        }).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getNewEvaluate();
            this.getGoodsForCoupons();
            this.getGoodRecommendedConsultant();
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {/*取消关注*/
        removeCollect({
          delType: 1, ids: this.bqwShop.id, shopType: this.bqwShop.shopType, request: 'form', type: 2,
          cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
          userId: this.cid != 0 && this.cid != undefined ? this.cid : 0
        }).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getNewEvaluate();
            this.getGoodsForCoupons();
            this.getGoodRecommendedConsultant();
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    /*服务保障详情*/
    serviceGuarantee() {
      this.dialogGuaranteeVisible = true;
    },
    /*联系客服*/
    ContactCustomer(){
      if (this.cid!=0){
        let routeData = this.$router.resolve({
          name: "onlineService",
          path: '/onlineService/index',
          query:{
            id:this.bqwShop.id
          }
        });
        window.open(routeData.href, '_blank')
      }else{
        this.$alert('您还没有登录,是否进行登录', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.replace({
              path: '/login'
            })
          }
        })
      }
    },
    copyPhone(){
      let clipboard = new this.clipboard('.copyBtn');
      clipboard.on('success', e => {
        this.$message({message: '复制成功,去分享吧！', type: 'success'});
        e.clearSelection();
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        this.$message.error('复制失败，请手动选择复制！');
      })
    }
  },
  mounted() {
    this.getNewEvaluate();
    this.getGoodsForCoupons();
    this.getGoodRecommendedConsultant();
    this.getHotSearchKeywords();
    /*商品轮播开始*/
    if (this.bigImg.length > 1) {
      this.$nextTick(() => {
        if (this.$refs.swiperTop) {
          const swiperTop = this.$refs.swiperTop.swiper
          const swiperThumbs = this.$refs.swiperThumbs.swiper
          swiperTop.controller.control = swiperThumbs
          swiperThumbs.controller.control = swiperTop
        }
      })
    }
  },
  beforeMount() {
    this.pName = this.$route.query.pName;
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
    if (sessionStorage.getItem('serviceList'))
      this.serviceList = JSON.parse(sessionStorage.getItem('serviceList'));
    if (sessionStorage.getItem('serviceData'))
      this.serviceData = JSON.parse(sessionStorage.getItem('serviceData'));
  },
}
</script>
<style scoped>
.guarantee-dialog >>> .el-dialog__body {
  padding: 0px 0px 30px 20px;
}

.guarantee-dialog >>> .span-gray {
  color: #333333;
  font-size: 16px;
}

.guarantee-dialog >>> .gray-p {
  color: #999;
  font-size: 12px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  padding-left: 20px;
}

.product-container >>> .service-content .el-autocomplete {
  border-radius: 6px;
}

.product-container >>> .el-icon-arrow-right {
  cursor: pointer;
}

.product-container >>> .service-content .el-input__inner {
  border-color: #FE273B;
}

.product-container >>> .service-content .el-input__prefix {
  left: 10px;
  transition: all .3s;
  font-size: 18px;
  font-weight: bold;
  padding-top: 7px;
}

.product-container >>> .service-content .el-input__suffix {
  right: 0px;
  transition: all .3s;
  pointer-events: none;
  padding-top: 0px;
}

.product-container >>> .service-content .el-input__inner:hover {
  border-color: #FE273B;
}

.product-container >>> .toolbar-content .left-toolbar .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-weight: 400;
}

.product-container >>> .toolbar-content .left-toolbar .el-breadcrumb__inner a,
.product-container >>> .toolbar-content .left-toolbar .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #666666;
  font-size: 14px;
}

.product-container >>> .toolbar-content .left-toolbar .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.product-container >>> .toolbar-content .left-toolbar .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.product-container >>> .toolbar-content .left-toolbar .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.product-container >>> .toolbar-content .left-toolbar .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: normal;
  color: #666666;
  cursor: text;
  font-size: 14px;
}

.product-container >>> .product-content .details-info .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  font-size: 14px;
  border-radius: 8px;
}

.product-container >>> .product-content .details-info .el-button--danger.is-plain {
  color: #FE273B;
  background-color: #ffffff;
  border-color: #FE273B;
  font-size: 14px;
  border-radius: 8px;
}

.product-container >>> .product-content .container-info .container-right-top .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  box-shadow: -1px 0 0 0 #fe273b;
}

.product-container >>> .product-content .container-info .container-right-top .el-radio-button__inner {
  background: center;
  border: none;
  color: #333333;
  padding: 20px 40px;
  font-size: 14px;
}

.product-container >>> .product-content .container-info .container-right-top .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0;
}

.product-container >>> .product-content .container-info .container-right-top .el-radio-button:first-child .el-radio-button__inner {
  border-left: none;
  border-radius: 0;
}

.product-container >>> .product-content .container-info .el-card__body, .el-main {
  padding: 0px 0px 0px 20px;
}

.product-container >>> .product-content .container-info .comment .comment-list .el-rate__icon {
  font-size: 20px;
  margin-right: 0px;
}

.el-icon-circle-check {
  color: #FE273B;
  font-size: 16px;
  font-weight: bold;
  padding-right: 3px;
}
</style>
<style scoped lang="scss">
.product-container {
  background: #ffffff;

  .service-content {
    padding: 0px 18%;
    background: #ffffff;
    min-width: 76rem;
    .title {
      font-size: 36px;
      cursor: context-menu;
      margin-block-start: 0em;
      margin-block-end: 0em;
      padding-top: 1em;

      .search-input {
        width: 40%;
        float: right;

        .red-btn {
          display: inline-block;
          width: 80px;
          height: 100%;
          background-color: #fd2f37;
          font-size: 16px;
          color: #ffffff;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          border-radius: 4px;
        }
      }
    }

    .recommend-search {
      width: max-content;
      margin-block-start: 0em;
      padding-top: 10px;
      margin-block-end: 0em;
      height: 40px;
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      justify-content: left;
      padding-left: 60%;

      .el-link {
        margin-right: 20px;
        font-size: 14px;
        color: #666666;
      }
    }
  }

  .navigator {
    background: #1E4165;
    padding: 10px 18%;
    min-width: 76rem;
    .link-white {
      color: #ffffff;
      font-size: 16px;
      margin: 0px 0px;
    }

    .el-divider {
      background: #ffffff;
      width: 2px;
      margin: 0px 20px;
    }
  }

  .toolbar-content {
    background: #F1F1F1;
    padding: 20px 18%;
    display: flex;
    align-items: center;
    min-width: 76rem;
    .left-toolbar {
      display: flex;
      align-items: center;
      color: #666666;
      font-size: 14px;
      width: 50%;
      float: left;
      justify-content: left;
    }

    .right-toolbar {
      display: flex;
      align-items: center;
      width: 50%;
      float: right;
      justify-content: right;

      .right-link {
        margin-left: 40px;
        color: #666666;

        .icon-bqw-shop, .icon-bqw-customer, .icon-bqw-follow , .icon-followed{
          color: #FE273B;
          font-size: 16px;
          padding-right: 5px;
        }
      }
    }
  }

  .product-content {
    padding: 10px 18% 10px 18%;
    min-width: 76rem;
    background: #ffffff;
    .swiper-wrapper-content {
      .imgList {
        width: 350px;
        height: 100px;
        margin-top: 20px;
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
      }

      .imgListShow {
        flex-shrink: 0;
        width: 100px;
        height: 100%;
        float: left;
        margin-right: 10px;
        border: 2px solid #ccc;
        box-sizing: border-box;
      }

      .imgListShow.active {
        border: 2px solid #1989FA;
      }

      .imgListShow img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .imgs {
        width: 350px;
        height: 350px;
      }

      .imgsList {
        width: 100%;
        height: 100%;
      }

      .imgsList img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .gallery-thumbs {
        height: 16% !important;
        box-sizing: border-box;
        padding: 0px 0;
      }

      .gallery-thumbs .swiper-slide {
        width: 25%;
        height: 100%;
        opacity: 0.4;
      }

      .gallery-thumbs .swiper-slide img {
        display: block;
        width: 100px;
        height: 100px;
      }

      .gallery-thumbs .swiper-slide-active {
        opacity: 1;
      }

      //用来改变按钮的颜色
      .swiper-button-prev {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l4.2%2C4.2L8.4%2C22l17.8%2C17.8L22%2C44L0%2C22z'%20fill%3D'%23999999'%2F%3E%3C%2Fsvg%3E");
      }

      .swiper-button-next {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L5%2C44l-4.2-4.2L18.6%2C22L0.8%2C4.2L5%2C0z'%20fill%3D'%23999999'%2F%3E%3C%2Fsvg%3E");
      }
    }

    .details-content {
      .title {
        color: #333333;
        font-size: 18px;
        margin-block-start: 0;
        margin-block-end: 0;
      }

      .info {
        margin-block-start: 0;
        margin-block-end: 0;
      }

      .span-default {
        font-size: 14px;
        color: #666666;
        width: 100px;
        display: inline-grid;
      }

      .span-red {
        font-size: 18px;
        color: #FE273B;

        .span-smaller {
          font-size: 14px;
        }
      }

      .details-info {
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: left;

        img {
          width: -webkit-fill-available;
        }

        .span-gray {
          font-size: 14px;
          color: #333333;
          padding-right: 10px;
          cursor: pointer;
        }
      }

      .preferential-amount {
        cursor: pointer;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
        color: #FE273B;
        float: left;
        margin-right: 10px;

        .preferential {
          background: url("~@/assets/img/cloud/coupon.png");
          width: 120px;
          height: 24px;
          background-size: 100% 100%;
        }

        .span-gray {
          font-size: 14px;
          color: #333333;
        }
      }
    }

    .shop {
      background: #F1F1F1;
      padding: 10px;
      cursor: pointer;

      .shop-info {
        display: flex;
        align-items: center;
        justify-content: left;
        padding: 10px;

        .user-content {
          padding-left: 10px;
          width: 100%;

          p {
            margin-block-start: 0;
            margin-block-end: 0;
            font-size: 14px;
            color: #333333;

            .icon-orange {
              font-style: normal;
              font-size: 12px;
              color: #ffffff;
              background: #FF9600;
              padding: 2px 5px;
              border-radius: 4px;
              cursor: pointer;
            }

            .icon-bqw-telephone {
              background: #FFE5E7;
              color: #FE273B;
              font-size: 14px;
              padding: 10px;
              border-radius: 50%;
              float: right;
              margin-top: -7px;
            }
          }

          .default-p {
            color: #666666;
            font-size: 12px;
            padding-top: 8px;
          }
        }
      }

      .statistics {
        display: flex;
        align-items: center;
        justify-content: space-around;
        background: #E1E3EF;
        text-align: center;
        margin: 10px 10px 10px;
        padding: 10px 0px;

        p {
          margin-block-start: 0;
          margin-block-end: 0;
          font-size: 16px;
          color: #666666;
        }

        .span-block {
          color: #333333;
        }
      }
    }

    .title-small {
      font-size: 14px;
      color: #333333;
      margin-block-start: 0;
    }

    .container-info {
      .container-left-top {
        .shop-title {
          padding: 18px 10px;
          background: #DDDDDD;
          font-size: 14px;
          color: #333333;
          border: 1px solid #DDDDDD;
        }

        .container-btn {
          display: flex;
          align-items: center;
          justify-content: space-around;

          .right-link {
            padding: 15px;
            border: 1px solid #DDDDDD;
            width: 100%;
            color: #333333;

            .icon-bqw-shop, .icon-bqw-customer, .icon-bqw-follow, .icon-followed{
              color: #FE273B;
              font-size: 16px;
              padding-right: 5px;
            }
          }
        }
      }

      .details-info {
        padding-top: 20px;
      }

      .container-left-bottom {
        margin-top: 20px;

        .shop-title {
          padding: 18px 10px;
          background: #DDDDDD;
          font-size: 14px;
          color: #333333;
          border: 1px solid #DDDDDD;
        }

        .recommend-list {
          padding: 15px;
          border: 1px solid #dddddd;

          .recommend-name {
            font-size: 16px;
            color: #333333;
            margin-block-start: 0;
            margin-block-end: 0;
            padding: 10px 0;
          }

          .recommend-price {
            font-size: 18px;
            color: #FE273B;
            padding: 0px 0px 10px;
            margin-block-start: 0;

            span {
              font-size: 14px;
              padding-right: 3px;
            }
          }
        }
      }

      .container-right-top {
        background: #F1F1F1;
      }

      .comment {
        padding: 20px;

        .comment-eval {
          display: flex;
          align-items: center;
          justify-content: left;

          .comment-score {
            cursor: pointer;
            float: left;
            text-align: center;

            .span-1 {
              font-size: 18px;
              color: #333333;
            }

            .span-red {
              font-size: 22px;
              color: #FE273B;
            }

            p {
              margin-block-start: 0;
              margin-block-end: 0;
            }
          }

          .eval {
            margin-left: 45px;

            .eval-label {
              font-style: normal;
              border: 1px solid #DDDDDD;
              padding: 12px 40px;
              border-radius: 6px;
              margin-right: 15px;
              cursor: pointer;
              font-size: 14px;
              color: #666666;
            }
          }
        }

        .comment-list {
          border-bottom: 1px solid #DDDDDD;
          padding: 20px 20px 20px 0px;

          .comment-user {
            display: flex;
            align-items: center;
            justify-content: left;
            float: left;
            margin-right: 60px;
            height: 50px;
            width: 140px;
          }

          .time {
            color: #666666;
            font-size: 14px;
            padding-top: 20px;
          }
        }

      }
    }
  }
}
</style>
<style>
.drawer-comment .el-drawer__header {
  align-items: center;
  color: #72767b;
  display: flex;
  margin-bottom: 0px;
  padding: 10px 20px;
}

.drawer-comment .coupon {
  width: 230px;
  height: 90px;
  background: #FFEBED;
  padding: 20px;
  margin-top: 15px;
  border-radius: 4px;
}

.drawer-comment .red-button {
  width: 15px;
  padding: 0 10px;
  font-size: 14px;
  color: rgb(255, 255, 255);
  position: absolute;
  right: 11px;
  margin-top: -110px;
  height: 130px;
  display: flex;
  line-height: 22px;
  align-items: center;
  cursor: pointer;
  background-image: -webkit-gradient(radial, 50% 0, 6, 50% 0, 6, from(#FFEBED), color-stop(100%, #FFEBED), color-stop(50%, rgb(254, 39, 59)), to(rgb(254, 39, 59)));
  background-size: 75px 10px;
  background-repeat: repeat-y;
  background-position: 100% 100%;
}

.drawer-comment .small-p {
  margin-block-start: 0em;
  margin-block-end: 0em;
  font-size: 14px;
  color: #333333;
  cursor: context-menu;
}

.drawer-comment .red-p {
  font-size: 14px;
  color: #FE273B;
}

.drawer-comment .disabled-button {
  width: 15px;
  padding: 0 10px;
  font-size: 14px;
  position: absolute;
  right: 11px;
  margin-top: -110px;
  height: 130px;
  display: flex;
  line-height: 22px;
  align-items: center;
  cursor: not-allowed;
  color: #ffffff;
  background-image: -webkit-gradient(radial, 50% 0, 6, 50% 0, 6, from(#FFEBED), color-stop(100%, #FFEBED), color-stop(50%, #fab6b6), to(#fab6b6));
  background-size: 75px 10px;
  background-repeat: repeat-y;
  background-position: 100% 100%;
}

.product-container .product-content .container-info .details-info img {
  width: -webkit-fill-available;
}

.product-container .product-content .container-info .details-info p {
  margin-block-start: 0px;
  margin-block-end: 0px;
}
</style>